import { Stack, Typography } from "@mui/material";
import React from "react";
import { RichTextField } from "../ConfigFields/RichTextField";
import { StringField } from "../ConfigFields/StringField";
import { BooleanField } from "../ConfigFields/BooleanField";
import { ColorsConstants } from "../../../../cssUtils/constants";

const RichTextMessagePreset = ({ schema, config, handleConfigChange }) => {
  return (
    <Stack spacing={3}>
      <RichTextField
        fieldKey="message"
        schema={schema?.properties["message"] || {}}
        value={config["message"]}
        required={true}
        onChange={(val) => handleConfigChange("message", val)}
      />

      <BooleanField
        fieldKey="compact_lines"
        schema={schema?.properties["compact_lines"] || {}}
        value={config["compact_lines"] ?? false}
        required={false}
        onChange={(val) => handleConfigChange("compact_lines", val)}
      />
      <Typography variant="body2" color={ColorsConstants.grayFontColor}>
        Yes: each line in the editor is a single new line (leave an empty line
        where you want a gap). No: every line is followed by a blank line.
      </Typography>

      <StringField
        fieldKey="header"
        schema={schema?.properties["header"] || {}}
        value={config["header"]}
        required={false}
        onChange={(val) => handleConfigChange("header", val)}
      />

      <StringField
        fieldKey="footer"
        schema={schema?.properties["footer"] || {}}
        value={config["footer"]}
        required={false}
        onChange={(val) => handleConfigChange("footer", val)}
      />
    </Stack>
  );
};

export default RichTextMessagePreset;
